import { z } from 'zod';
const secret = z
    .string()
    .trim()
    .min(1, 'Enter an access token')
    .max(8192)
    .regex(/^[^\r\n]+$/);
const identifier = z
    .string()
    .trim()
    .min(1)
    .max(128)
    .regex(/^[a-zA-Z0-9_-]+$/);
export const mailDnsConnectionSchema = z.discriminatedUnion('provider', [
    z.object({
        provider: z.literal('cloudflare'),
        token: secret,
        zoneId: z.string().regex(/^[a-fA-F0-9]{32}$/, 'Enter the 32-character Cloudflare zone ID'),
    }),
    z.object({ provider: z.literal('godaddy'), token: secret }),
    z.object({
        provider: z.literal('google'),
        token: secret,
        project: identifier,
        zone: identifier,
    }),
]);
export const mailDnsSetupSchema = z.object({
    connection: mailDnsConnectionSchema,
    fingerprint: z
        .string()
        .regex(/^[a-f0-9]{64}$/)
        .optional(),
    replaceMx: z.boolean().default(false),
});
